// Styled Components
import styled from 'styled-components';
import { Flex } from '../components/shared/Flex';
import media from '../style/media';

export const PageContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: radial-gradient(circle at top right, #4158d0 0%, #506ac8ff 46%, #7570ffff 100%);
  background-attachment: fixed;
  position: relative;
  overflow-x: hidden;
  font-family: 'Outfit', 'Inter', -apple-system, sans-serif;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 100px 20px 40px;
  margin: 0 auto;
  box-sizing: border-box;
  z-index: 1;
  animation: fadeIn 0.8s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: white;
  margin: 0;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-shadow: 0 10px 20px rgba(0,0,0,0.1);

  ${media.tablet`
    font-size: 3.5rem;
  `}
`;

export const Subtitle = styled.p`
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 1rem 0 0;
  line-height: 1.6;
  font-weight: 500;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;

  ${media.tablet`
    font-size: 1.25rem;
  `}
`;

export const GlassCard = styled.div`
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(25px) saturate(180%);
  -webkit-backdrop-filter: blur(25px) saturate(180%);
  border-radius: 40px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: 2.5rem 1.5rem;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  transition: transform 0.3s ease;

  ${media.tablet`
    padding: 4rem;
  `}
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;

  ${media.mobile`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${media.tablet`
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  `}
`;

export const Field = styled.div`
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 24px;
  padding: 1.5rem;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
    background: white;
  }
`;

export const FieldLabel = styled.div`
  font-size: 0.8rem;
  color: #64748b;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 0.75rem;
`;

export const FieldValue = styled.div`
  font-size: 1.5rem;
  color: #1e293b;
  font-weight: 800;
`;
